import { Head, Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'

import { Button } from '@/components/ui/button.tsx'
import Form from './form.tsx'
import type { UserType } from './types.ts'

interface EditProps {
  user: UserType
  can_assign_super_admin: boolean
  can_update_user: boolean
}

export default function Edit({ user, can_assign_super_admin, can_update_user }: EditProps) {
  return (
    <>
      <Head title="Modifier l'utilisateur" />

      <div className="space-y-6 p-8">
        <div className="flex items-center gap-4">
          <Link href={`/admin/users/${user.id}`}>
            <Button variant="ghost" size="sm">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour
            </Button>
          </Link>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Modifier l'utilisateur</h1>
            <p className="text-muted-foreground">Mettre à jour les informations et les accès du compte.</p>
          </div>
        </div>

        <Form
          user={user}
          canAssignSuperAdmin={can_assign_super_admin}
          canCreateUser={can_update_user}
          method="patch"
          action={`/admin/users/${user.id}`}
          submitText="Enregistrer les modifications"
        />
      </div>
    </>
  )
}
